<template>
    <div class="monthTopic">
        <div class="title">
            最新共享稿件
        </div>
        <div class="list">
            <ul>
                <li v-for="(item, index) in dataList" class="clearBoth" @click="detail(item)">
                    <a>
                        <div class="item-all">
                            <span class="item-tag"></span>
                            <div class="item-content">
                                <img class="item-img" v-if="item.imgUrl && !item.XQ_VideoUrl" :src="item.imgUrl" alt="">
                                
                                <div class="item-video" v-if="item.XQ_VideoUrl">
                                    <div class="video-detail"><video width=100% height=100% :src="item.XQ_VideoUrl"></video></div>
                                    <div class="video-icon-detail"><img class="video-play" src="../../../assets/images/springFrame/video.png" alt="" /></div>
                                </div>
                                
                                <div class="item-title" :style="{width: item.imgUrl || item.XQ_VideoUrl ? '75%':'92%'}" :title="item.title">{{ item.title }}</div>
                                <div class="item-both">
                                    <span class="name">{{ item.shareName }}</span>
                                    <span class="time">{{ item.shareTime }}</span>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        <pub-detail-manuscript v-model="showMore" @showManuJZ="showManuJZ" :showObj="showObj" :isShowBig="isShowBig"></pub-detail-manuscript>
    </div>
</template>

<script>
    import PubDetailManuscript from '@/views/index/pubFolder/pubDetail.vue';

    export default {
        name: "newShareManuscript",
        data() {
            return {
                isShowBig: false,
                showObj: {},
                showMore: false,
                dataList: [],
                headTitle: '最新共享稿件',
                headTitleTag: 'zxgxgj',
                imgBtnNo: false,
                imgBtnHave: false,
                imgBtnOne: false,
                timer: null
            }
        },
        components: { PubDetailManuscript },
        mounted(){
            this.getData();
            this.timer =setInterval(() => {
                this.getData();
            }, 1000*60*15);
        },
        methods: {
            getData(){
                this.axios.get('/bigscreen/zuixinhuichuan.json').then(res => {
                    this.dataList = res.data.data.newData;

                    // this.dataList[1].XQ_PicUrl = [
                    //    {picUrl: "http://121.194.3.144/webpic/W0202206/W020220628/W020220628599220249088.jpg"},
                    //     {picUrl: "http://121.194.3.144/webpic/W0202206/W020220628/W020220628599221562723.jpg"},
                    //    {picUrl: "http://121.194.3.144/webpic/W0202206/W020220628/W020220628599223942514.jpg"},
                    //    {picUrl: "http://121.194.3.144/webpic/W0202206/W020220628/W020220628599229455669.jpg"},
                    // ]; 

                })
            },
            detail(item){
                this.showMore = true;
                this.isShowBig = true;
                item.headTitle = this.headTitle;
                item.headTitleTag = this.headTitleTag;
                if(item.XQ_PicUrl.length ==1){
                    this.imgBtnOne = true;
                    this.imgBtnNo = false;
                    this.imgBtnHave = false;
                } else {
                    this.imgBtnOne = false;
                    this.imgBtnNo = false;
                    this.imgBtnHave = true;
                }
                
                item.imgBtnNo = this.imgBtnNo;
                item.imgBtnHave = this.imgBtnHave;
                item.imgBtnOne = this.imgBtnOne;
                
                this.showObj = item;
            },
            showManuJZ(row) {
                this.isShowBig = row;
            }
        },
        beforeDestroy(){
            clearInterval(this.timer);
        },
    }
</script>

<style scoped>
    .monthTopic{
        color: #fff;
        width:auto;
        overflow-y: hidden;
        height: 520px;

        margin-top: 85px;
    }
    .monthTopic .title{
        background: url("../../../assets/images/shareOrAdoptLab.png") center center no-repeat;
        background-size: 100% 100%;
        font-size: 42px;
        line-height: 67px;
        height: 67px;
        text-align: center;
        font-family: hyk1gj;
        /*font-weight: bold;*/
    }
    .monthTopic ul{
        margin-top: 20px;
        height: 420px;    
        
    }

    ul li {
        padding: 10px 0;
        height: 120px;
    }
    ul li .item-title{
        margin-top: 20px;
        font-size: 32px;
        line-height: 32px;
        margin-bottom: 20px;
        color: rgb(246,247,246);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 92%;
        float:left;
        margin-left: 20px;
    }
    ul li a {
        display: block;
        width: 100%;
        height: 100%;
        background: url("../../../assets/images/shareML.png") center center no-repeat;

    }
    ul li a .item-all {
        margin-left: 30px;
    }
    ul li a .item-all .item-content {
        margin-left: 30px;
    }
    ul li .item-both {
    }
    ul li .item-both .name{
        font-size: 28px;
        color: #88b5fb;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 20%;
        line-height: 28px;
        float: left;
        margin-left: 20px;
    }
    ul li .item-both .time{
        font-size: 28px;
        color: #88b5fb;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 50%;
        line-height: 28px;
    }
    ul li .item-img {
        width: 120px;
        height: 80px;
        float: left;
        margin-top: 20px;
        margin-left: 20px;
    }
    ul li .item-video {
        width: 120px;
        height: 80px;
        float: left;
        margin-top: 20px;
        margin-left: 20px;
        background-color: #000;
    }
    ul li .item-video .video-detail {
        float: left;
        width: 120px;
        height: 80px;
    }
    ul li .item-video .video-icon-detail {
        position: absolute;
        float:left;
    }
    ul li .item-video .video-play {
        width: 60px;
        margin-left: 28px;
        margin-top: 8px;
    }
    ul li .item-tag {
            width: 12px;
            height: 12px;
            background-color: rgb(57, 254, 247);
            margin-top: 60px;
            float:left;
        }
        
    
</style>
